<template>
  <div id="app">
    <div v-if="loading" class="page-loader">
      <hollow-dots-spinner
        :animation-duration="1000"
        :dot-size="15"
        :dots-num="3"
        color="#20409a"
      />
    </div>
    <div v-else>
      <vue-progress-bar></vue-progress-bar>
      <router-view />
    </div>
  </div>
</template>

<script>
import { HollowDotsSpinner } from "epic-spinners";

export default {
  name: "app",
  components: {
    HollowDotsSpinner
  },
  data() {
    return {
      loading: true
    };
  },
  created() {
    this.$Progress.start();
    this.$router.beforeEach((to, from, next) => {
      if (to.meta.progress !== undefined) {
        let meta = to.meta.progress;
        this.$Progress.parseMeta(meta);
      }
      this.$Progress.start();
      next();
    });
    this.$router.afterEach(() => {
      this.$Progress.finish();
    });
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
      this.$Progress.finish();
    }, 3000);
  }
};
</script>

<style>
.page-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

/* @font-face {
  font-family: "BwAletaNo10";
  src: url("~@/assets/kovatek/FONTS/BwAletaNo20-Regular.otf") format("opentype"),
    url("~@/assets/kovatek/FONTS/BwAletaNo10-Black.otf") format("opentype"),
    url("~@/assets/kovatek/FONTS/BwAletaNo10-BlackItalic.otf")
      format("opentype"),
    url("~@/assets/kovatek/FONTS/BwAletaNo10-Bold.otf") format("opentype"),
    url("~@/assets/kovatek/FONTS/BwAletaNo10-BoldItalic.otf") format("opentype"),
    url("~@/assets/kovatek/FONTS/BwAletaNo10-RegularItalic.otf")
      format("opentype");
  font-weight: normal;
  font-style: normal;
}

#app {
  font-family: "BwAletaNo10", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;

} */

@font-face {
  font-family: "Roboto";
  src: url("~@/assets/kovatek/FONTS/Roboto-Regular.ttf") format("truetype"),
    url("~@/assets/kovatek/FONTS/Roboto-Bold.ttf") format("truetype"),
    url("~@/assets/kovatek/FONTS/Roboto-BoldItalic.ttf") format("truetype"),
    url("~@/assets/kovatek/FONTS/Roboto-Italic.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}

#app {
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
} */

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
.kovatek-width {
  max-width: 1350px;
  margin: auto;
}
.kova-text {
  color: #20409a;
}
.kova-bg {
  background-color: #20409a;
}
.btn-kovatek {
  background-color: #20409a;
  color: #fff;
  transition: 0.25s;
  border: solid 1px #20409a;
  outline: 0;
}
.btn-kovatek:hover {
  background-color: #06216d;
  color: #fff;
}
.btn-outline-kovatek {
  background-color: #fff;
  border: solid 1px #20409a;
  outline: 0;
  color: #20409a;
  transition: 0.25s;
}
.btn-outline-kovatek:hover {
  background-color: #f1f1f1;
  border: solid 1px #20409a;
  color: #20409a;
}
.go-back {
  position: relative;
  top: 2px;
  color: #2db7f5;
  cursor: pointer;
}
.intermediate {
  color: #acac21;
}
.pointer {
  cursor: pointer;
}
.kova-green {
  color: #4bb38e;
}
.kova-bg-green {
  background-color: #4bb38e;
}
.kova-light {
  color: #ababab;
}
.kova-id {
  height: 20px;
  background-color: #4bb38e;
  border-radius: 5px;
}
.btn-rounded {
  border-radius: 30px;
}
.ant-color {
  color: #2bd7f5;
}
.light-blue {
  background-color: rgba(32, 64, 154, 0.25);
}
.see-more {
  background-color: transparent;
  border: solid 1.5px #fff;
  border-radius: 20px;
  color: #fff;
  transition: 0.25s;
}
.see-more:hover {
  background-color: #fff;
  color: #20409a;
}
.radio {
  position: relative;
  cursor: pointer;
  line-height: 20px;
  font-size: 16px;
  margin: 15px;
}

.label {
  position: relative;
  display: block;
  float: left;
  margin-right: 10px;
  width: 20px;
  height: 20px;
  border: 1px solid #20409a;
  border-radius: 100%;
  -webkit-tap-highlight-color: transparent;
}

.label::after {
  content: "";
  position: absolute;
  top: 4px;
  left: 4px;
  width: 10px;
  height: 10px;
  border-radius: 100%;
  background: #20409a;
  transform: scale(0);
  transition: all 0.5s ease;
  opacity: 0.08;
  pointer-events: none;
}

.label:hover + .label::after {
  transform: scale(3.6);
}

input[type="radio"]:checked + .label {
  border-color: #20409a;
}

input[type="radio"]:checked + .label::after {
  transform: scale(1);
  transition: all 0.5s cubic-bezier(0.35, 0.9, 0.4, 0.9);
  opacity: 1;
}
.hidden {
  display: none;
}
.scrollbar::-webkit-scrollbar {
  background-color: #fff;
  width: 16px;
}

/* background of the scrollbar except button or resizer */
.scrollbar::-webkit-scrollbar-track {
  background-color: #fff;
}
.scrollbar::-webkit-scrollbar-track:hover {
  background-color: #f4f4f4;
}

/* scrollbar itself */
.scrollbar::-webkit-scrollbar-thumb {
  /* background-color:#babac0; */
  background-color: #20409a;
  border-radius: 16px;
  border: 5px solid #fff;
}
.scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: #a0a0a5;
  border: 4px solid #f4f4f4;
}
.scrollbar::-webkit-scrollbar-button {
  display: none;
}

/* styling checkbox */
.checkbox-label {
  display: block;
  position: relative;
  cursor: pointer;
  font-size: 22px;
  line-height: 24px;
  height: 20px;
  width: 100%;
}
.checkbox-label input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.checkbox-label .checkbox-custom {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 21px;
  width: 21px;
  background-color: transparent;
  border-radius: 5px;
  transition: all 0.3s ease-out;
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  /* border: 2px solid #20409a; */
  background: linear-gradient(to bottom, #4bb38e, #20409a);
}
.checkbox-label input:checked ~ .checkbox-custom {
  background: linear-gradient(to bottom, #4bb38e, #20409a);
  border-radius: 5px;
  -webkit-transform: rotate(0deg) scale(1);
  -ms-transform: rotate(0deg) scale(1);
  transform: rotate(0deg) scale(1);
  opacity: 1;
  /* border: 2px solid #20409a; */
  border: solid 0;
}
.checkbox-label .checkbox-custom::after {
  position: absolute;
  content: "";
  left: 12px;
  top: 12px;
  height: 0px;
  width: 0px;
  border-radius: 5px;
  border: solid #20409a;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(0deg) scale(0);
  -ms-transform: rotate(0deg) scale(0);
  transform: rotate(0deg) scale(0);
  opacity: 1;
  transition: all 0.3s ease-out;
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
}
.checkbox-label input:checked ~ .checkbox-custom::after {
  -webkit-transform: rotate(45deg) scale(1);
  -ms-transform: rotate(45deg) scale(1);
  transform: rotate(45deg) scale(1);
  opacity: 1;
  left: 8px;
  top: 3px;
  width: 6px;
  height: 12px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  background-color: transparent;
  border-radius: 0;
}
/* For Ripple Effect */
.checkbox-label .checkbox-custom::before {
  position: absolute;
  content: "";
  left: 10px;
  top: 10px;
  width: 0px;
  height: 0px;
  border-radius: 5px;
  border: 2px solid #20409a;
  -webkit-transform: scale(0);
  -ms-transform: scale(0);
  transform: scale(0);
}
.checkbox-label input:checked ~ .checkbox-custom::before {
  left: -3px;
  top: -3px;
  width: 24px;
  height: 24px;
  border-radius: 5px;
  -webkit-transform: scale(3);
  -ms-transform: scale(3);
  transform: scale(3);
  opacity: 0;
  z-index: 999;
  transition: all 0.3s ease-out;
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
}
.add-rounded {
  border-radius: 10px;
}
</style>
